/* Fundae · Elevated PDP (Drawer) — PHASE 1 behaviour
   Gallery swap · real-variant size selection wired to the ATC form ·
   drawer open/close · reveal-on-scroll. P2 adds the metafield-driven
   flavour / cone / material-filter / topping configurator. */
/* Re-runnable on purpose. A Section Rendering swap replaces #fpe wholesale, which kills every
   listener bound to the old nodes — that is the point — so the whole module has to be able to run
   again against the new DOM. Everything below is therefore a function, called once on load and
   again after each swap.

   Listeners on window/document are the exception: those survive a swap and would stack up one
   copy per option click. They are bound once, guarded by FPE_GLOBALS_BOUND. */
window.FPE_INIT = function () {
  "use strict";
  // Read the payload from the DOM every time, not from window.FPE. A script element inserted by
  // DOMParser does NOT execute, so the section's own inline parser never runs after a swap and
  // window.FPE would still describe the variant the shopper just navigated away from.
  var el = document.getElementById("fpe-data");
  if (el) { try { window.FPE = JSON.parse(el.textContent); } catch (e) {} }
  var FPE = window.FPE || { variants: [], sizePosition: 0 };
  var firstRun = !window.FPE_GLOBALS_BOUND;
  window.FPE_GLOBALS_BOUND = true;
  var $ = function (id) { return document.getElementById(id); };
  var fpe = $("fpe");

  // ---- announcements ----
  // #fpeStatus is a role="status" aria-live="polite" region in the section markup. Everything
  // that changes state silently — sold out, variant change, the whole-product flavour swap —
  // routes through here. The visual toast is decoration on top of it, not the message itself.
  var toastEl, toastT;
  function announce(msg) {
    var s = $("fpeStatus"); if (s) s.textContent = msg;
  }
  function toast(msg) {
    announce(msg);
    if (!toastEl) { toastEl = document.createElement("div"); toastEl.className = "fpe-toast"; document.body.appendChild(toastEl); }
    toastEl.textContent = msg; toastEl.classList.add("show");
    clearTimeout(toastT); toastT = setTimeout(function () { toastEl.classList.remove("show"); }, 2200);
  }

  var ui = { vegan: false, recycled: false, flavNative: true, heelNative: true, baseImg: null };

  // Checked at CALL time, not hoisted — a hoisted read misses a user changing the OS setting
  // mid-session, and the CSS clamps transitions to .001ms under reduce, which turned the old
  // unconditional `opacity=0; setTimeout(150)` into a 150ms hard blank of the hero image.
  function reduceMotion() {
    return window.matchMedia && matchMedia("(prefers-reduced-motion: reduce)").matches;
  }
  // Single hero writer. alt travels WITH src: after a flavour swap the URL, the photo and the
  // accessible name must all describe the same product.
  function setHero(src, alt) {
    var hero = $("heroImg"); if (!hero || !src) return;
    if (hero.getAttribute("src") === src) { if (alt) hero.alt = alt; return; }
    if (reduceMotion()) { hero.src = src; if (alt) hero.alt = alt; return; }
    hero.style.opacity = 0;
    setTimeout(function () { hero.src = src; if (alt) hero.alt = alt; hero.style.opacity = 1; }, 150);
  }

  // hero badge column — the vegan flag, plus a badge per topping the shopper has chosen.
  //
  // Topping badges over the photo existed once and were removed with the hardcoded ADDONS list
  // (see the removal note below), because that list invented its own names, prices and images.
  // They are back on real data: name, thumbnail and variant all come from the actual product in
  // the picker. The .topbadge styling survived the removal, so this is the design it was drawn
  // for rather than a new one.
  //
  // ui.extras is the single source of truth, written by the pickers' sync(). This function
  // rebuilds the whole column, and a flavour swap calls it — so a badge cannot outlive the
  // selection that produced it.
  // Captured once from the server-rendered pill: the badge label is a section setting.
  var RECYCLED_LABEL = (function () {
    var el = document.querySelector(".recycledflag");
    return el ? (el.textContent || "").trim() : "";
  })();

  function renderBadges() {
    var col = $("badgeCol"); if (!col) return; col.innerHTML = "";
    if (ui.vegan) { var v = document.createElement("span"); v.className = "veganflag"; v.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" aria-hidden="true"><path d="M4 20c0-7 5-13 16-13 0 8-6 13-13 13H4z"/><path d="M4 20c4-6 8-9 12-10.5"/></svg>Vegan'; col.appendChild(v); }
    // Recycled is its own claim and crosses vegan: Recycled Leather earns this and not the leaf,
    // Cork earns the leaf and not this, Recycled Water Bottles earns both. The label is a merchant
    // setting, so it is read off the first server-rendered pill rather than hardcoded here — the
    // same trap the Add-to-bag label fell into, where the literal won back on the first swap.
    if (ui.recycled) {
      var r = document.createElement("span"); r.className = "recycledflag";
      r.innerHTML = "<svg viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"1.7\" stroke-linecap=\"round\" stroke-linejoin=\"round\" aria-hidden=\"true\"><path d=\"M7 19H4.8a1.8 1.8 0 0 1-1.55-2.7l2.2-3.75\"/><path d=\"m9.2 7.9-2.3 3.9-3.4-2\"/><path d=\"M12.4 4.6 10.2 8.4l3.5 2\"/><path d=\"M14.6 4.5a1.8 1.8 0 0 0-3.1 0\"/><path d=\"m20.8 13.3-2.2-3.8\"/><path d=\"m17.3 8.6 1.3 4.3 3.8-1.1\"/><path d=\"M16.8 19h2.4a1.8 1.8 0 0 0 1.55-2.7\"/><path d=\"M7 19h9.8m-2.5-2.9 2.9 2.9-2.9 2.9\"/></svg>" + (RECYCLED_LABEL || "Recycled");
      col.appendChild(r);
    }
    (ui.extras || []).forEach(function (t) {
      var b = document.createElement("span");
      b.className = "topbadge";
      // textContent for the name, never innerHTML: it comes from a product title and titles in
      // this catalogue contain & and other characters that would be parsed as markup.
      if (t.thumb) {
        var w = document.createElement("span"); w.className = "thumb";
        var i = document.createElement("img"); i.src = t.thumb; i.alt = ""; i.width = 26; i.height = 26;
        i.loading = "lazy";
        w.appendChild(i); b.appendChild(w);
      }
      var n = document.createElement("span"); n.className = "tn";
      n.textContent = t.short || t.name;
      b.appendChild(n);
      col.appendChild(b);
    });
  }

  /* REMOVED — the hardcoded ADDONS catalogue and money().
     ADDONS declared four toppings with baked-in names, prices, CDN image URLs and swatch hexes.
     Two of them ("Marshmallows $48", "Sour Straws $35") do not exist in the store at those
     prices at all, and two more carried stale names — the product actually called
     "Be Knotty | Revitalized Remnant Materials ^ Magnet" was labelled "Pretzel Bow". It was also
     4 of 10+ live toppings. Worse, ui.modeTopping defaulted to ADDONS[0], so every À La Mode
     shoe asserted "Puffy Bow — Included. Sewn on and permanent" as a fact about its hardware.
     money() emitted "$485" where the shop's own moneyFormat gives "$485.00", and dropped
     thousands separators.
     Toppings are real products with real prices. They are now linked from the section to the
     toppings collection instead of simulated here. A real configurator must render them from
     Liquid with variant IDs so they can become genuine line items. */


  /* ---- extras: toppings AND add-ons ------------------------------------------------------
     Two pickers, one mechanism. Toppings are magnetic hardware offered from a collection to any
     magnetic pair; add-ons (ankle bracelets and the like) are a per-product list read from
     custom.addons. They differ in where they come from and when they may attach, and in nothing
     else that matters here — both end up as their OWN cart line item, which is the entire point:
     the shoe has exactly one stock record, so each extra draws down its own.

     Collected by the data-extra attribute rather than by class, so adding a third kind of extra
     later is a Liquid change and not a JS change.

     Progressive enhancement: if fetch is unavailable or the request fails, the native form post
     still runs and the shoe alone lands in the cart. A shopper never ends up with nothing. */
  (function () {
    var form = document.getElementById("fpe-form");
    if (!form) return;

    function chosen(kind) {
      var sel = kind ? 'input[data-extra="' + kind + '"]:checked' : "input[data-extra]:checked";
      return [].slice.call(form.querySelectorAll(sel)).map(function (cb) {
        return { id: cb.dataset.variant, name: cb.dataset.name, kind: cb.dataset.extra,
                 short: cb.dataset.short, thumb: cb.dataset.thumb };
      });
    }

    function say(id, picked, noun) {
      var el = $(id); if (!el) return;
      el.textContent = picked.length === 0
        ? "No " + noun + "s selected"
        : picked.length + " " + noun + (picked.length === 1 ? " selected: " : "s selected: ") +
          picked.map(function (t) { return t.name; }).join(", ");
    }

    function sync() {
      var picked = chosen();
      // Publish before painting: renderBadges reads ui.extras, and a flavour swap calls it
      // independently of this function.
      ui.extras = picked;
      renderBadges();
      say("fpeAddonsState", chosen("topping"), "topping");
      say("fpeAddonPickState", chosen("addon"), "add-on");
      // The button keeps the shop-formatted price it was rendered with. No money arithmetic here
      // on purpose — see the snippet's header for why the old money() was wrong.
      var btn = $("addBtn");
      if (btn && btn.dataset.defaultText) {
        btn.textContent = picked.length
          ? btn.dataset.defaultText + "  +  " + picked.length + (picked.length === 1 ? " extra" : " extras")
          : btn.dataset.defaultText;
      }
    }

    // A flavour swap needs to be able to reset these, so it is reachable from outside.
    ui.syncAddons = sync;

    // Delegated on the FORM, so both panels are covered and neither has to exist.
    form.addEventListener("change", function (e) {
      var cb = e.target;
      if (!cb || !cb.dataset || !cb.dataset.extra) return;
      var card = cb.closest(".addon") || cb.closest(".addonpick-item");
      if (card) card.classList.toggle("on", cb.checked);
      sync();
    });
    sync();

    form.addEventListener("submit", function (e) {
      var picked = chosen();
      if (!picked.length) return;                       // nothing extra — let the native post run
      if (typeof fetch !== "function") return;

      var idField = document.getElementById("fpe-variant-id");
      if (!idField || !idField.value) return;           // no resolved variant; native post will 422 honestly

      e.preventDefault();
      var btn = $("addBtn");
      if (btn) { btn.disabled = true; btn.textContent = "Adding\u2026"; }

      // Quantity comes from the merchant quantity_selector block when a template declares one.
      // This used to be hardcoded to 1, so picking any topping silently discarded the shopper's
      // quantity — the native post honoured it, this path did not, and the two disagreed. Absent
      // block (the default) means no field, which still means 1.
      var qtyEl = form.querySelector('[name="quantity"]');
      var qty = Math.max(1, parseInt(qtyEl && qtyEl.value, 10) || 1);

      // The shoe carries a human-readable note naming what was chosen, so the pick is legible
      // on the order and the packing slip without cross-referencing the other lines. The extras
      // themselves are still separate lines — the note is a label, not the record.
      var items = [{
        id: Number(idField.value),
        quantity: qty,
        properties: { "Added": picked.map(function (t) { return t.name; }).join(", ") }
      }];
      // One topping per pair: two pairs with a bow means two bows, not one shared between them.
      picked.forEach(function (t) { items.push({ id: Number(t.id), quantity: qty }); });

      fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json", "Accept": "application/json" },
        body: JSON.stringify({ items: items })
      }).then(function (r) {
        if (!r.ok) throw new Error("cart rejected the items");
        window.location.href = "/cart";
      }).catch(function () {
        // Fall back to the plain post rather than stranding the shopper on a dead button.
        if (btn) { btn.disabled = false; sync(); }
        form.submit();
      });
    });
  })();

  /* ---- the composed heading ------------------------------------------------------------
     Mirrors snippets/fundae-product-title.liquid exactly. If the two ever disagree the page will
     flicker between two different headings on the first swap, so treat them as one unit.
     Falls back to the raw product title when a product carries neither category nor style —
     apparel, totes and gift cards land here, and an empty <h1> is worse than an ugly one. */
  function setPart(id, text, wrap) {
    var el = $(id);
    if (!el) return;
    if (text) { el.innerHTML = wrap ? wrap(text) : esc(text); el.hidden = false; }
    else { el.textContent = ""; el.hidden = true; }
  }
  function esc(t) {
    return String(t).replace(/[&<>"]/g, function (c) {
      return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;" }[c];
    });
  }
  function renderComposedTitle(fd) {
    if (!fd) return;
    var h1 = $("fpeTitle");
    if (!h1) return;
    var composed = !!(fd.cat || fd.style);

    if (!composed) {
      h1.className = "title";
      h1.textContent = fd.title || "";
    } else {
      h1.className = "title composed";
      h1.innerHTML =
        (fd.cat ? '<span class="t-cat" id="fpeTitleCat">' + esc(fd.cat) + "</span>" : "") +
        (fd.style ? '<span class="t-style" id="fpeTitleStyle">' + esc(fd.style) + "</span>" : "");
    }

    // spec line — each row independently gated, same rules as the Liquid
    var showHeel = fd.isShoe && fd.coneIsHeel && (fd.cone || fd.coneType);
    var showAla = fd.isShoe && fd.ala;
    setPart("fpeSpecMat", fd.mat, function (t) { return "<i>made from</i> <b>" + esc(t) + "</b>"; });
    setPart("fpeSpecHeel", showHeel ? ((fd.cone || "") + (fd.cone && fd.coneType ? " " : "") + (fd.coneType || "")) : "",
            function (t) { return "<i>on a</i> <b>" + esc(t) + "</b>"; });
    setPart("fpeSpecAla", showAla ? fd.ala : "");
    var spec = $("fpeSpec");
    if (spec) spec.hidden = !(fd.mat || showHeel || showAla);
  }

  // ---- gallery (event-delegated so the rail can be rebuilt on flavour swap) ----
  (function () {
    var rail = $("rail"); if (!rail) return;
    rail.addEventListener("click", function (e) {
      var b = e.target.closest && e.target.closest("button[data-src]");
      if (!b || !rail.contains(b)) return;
      [].forEach.call(rail.children, function (x) { x.classList.remove("active"); x.removeAttribute("aria-current"); });
      b.classList.add("active");
      b.setAttribute("aria-current", "true");
      setHero(b.dataset.src, null);
    });
    // flavour swap rebuilds the thumbnail rail for the newly-selected product
    ui.rebuildRail = function (images) {
      if (!images || !images.length) return;
      rail.innerHTML = images.map(function (src, i) {
        return '<button type="button" data-src="' + src + '" aria-label="Show image ' + (i + 1) + ' of ' + images.length + '"' + (i === 0 ? ' class="active" aria-current="true"' : '') + '><img src="' + src + '" alt="" width="220" height="220" loading="lazy"></button>';
      }).join("");
    };
  })();

  /* ---- past the Liquid cap: let the SERVER resolve --------------------------------------
     Liquid hands a template at most 250 variants and truncates SILENTLY. A consolidated product
     goes past that — Cherriots becomes 684 — so the page cannot trust its own variant array and
     must stop resolving combinations locally.

     It does not need to. `option.values[].variant` is context-aware: with one option selected,
     every value of every OTHER option already resolves to the variant you would land on by
     changing just that one and keeping the rest. So the server can answer any combination, and
     the client's job shrinks to "ask for that variant and swap in the answer".

     One option click = one request to the Section Rendering API for the SAME section, which
     returns just this section's HTML rather than the whole page.

     Progressive enhancement: if fetch is missing or the request fails, this falls back to a plain
     navigation to the same URL. The shopper always gets there; slower is not broken. */
  var SectionRender = (function () {
    var root = $("fpe");
    var busy = false;

    function enabled() {
      var m = Engine && Engine.model && Engine.model();
      return !!(root && m && m.pastCap && root.getAttribute("data-section-id"));
    }

    function urlFor(variantId) {
      var base = root.getAttribute("data-product-url") || location.pathname;
      return base + "?variant=" + encodeURIComponent(variantId);
    }

    function go(variantId) {
      if (!variantId) return false;
      var target = urlFor(variantId);
      if (typeof fetch !== "function" || busy) { location.href = target; return true; }
      busy = true;
      if (root) root.setAttribute("aria-busy", "true");
      announce("Loading\u2026");

      // section_id comes from the DOM, which read it from section.id. Never build it: the
      // section-TYPE form also returns 200 and drops the template's settings with it.
      var sid = root.getAttribute("data-section-id");
      fetch(target + "&section_id=" + encodeURIComponent(sid), { headers: { "X-Requested-With": "fetch" } })
        .then(function (r) {
          if (!r.ok) throw new Error("section render " + r.status);
          return r.text();
        })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, "text/html");
          // Swap the whole <section>, not just #fpe. The payload script #fpe-data is a SIBLING of
          // #fpe rather than a child, so replacing #fpe alone leaves the OLD payload in the
          // document and the fresh init re-reads the variant the shopper just navigated away
          // from — the picker comes back still showing the previous size. Measured exactly that
          // before fixing it. The Section Rendering response wraps both in one <section>.
          var wrapper = document.getElementById("shopify-section-" + sid);
          var next = doc.getElementById("shopify-section-" + sid);
          if (!wrapper || !next) {
            // Fall back to the narrower swap plus an explicit payload swap, so a theme that ever
            // renders this section without the standard wrapper still updates correctly.
            next = doc.getElementById("fpe");
            var nextData = doc.getElementById("fpe-data");
            var oldData = document.getElementById("fpe-data");
            if (!next) throw new Error("no section or #fpe in the response");
            root.parentNode.replaceChild(next, root);
            if (nextData && oldData) oldData.parentNode.replaceChild(nextData, oldData);
          } else {
            wrapper.parentNode.replaceChild(next, wrapper);
          }
          root = document.getElementById("fpe");
          if (window.history && history.pushState) history.pushState({ v: variantId }, "", target);
          busy = false;
          if (window.FPE_INIT) window.FPE_INIT();
        })
        .catch(function () {
          busy = false;
          location.href = target;                       // never strand the shopper on a dead click
        });
      return true;
    }

    return { enabled: enabled, go: go };
  })();

  // ---- option model -> variant resolution ------------------------------------------------
  // The catalogue is mid-migration, so option COUNT (2 or 3), ORDER and NAME all vary between
  // siblings in the same family — see snippets/fundae-option-axes.liquid for the proof. Nothing
  // in here may assume a fixed shape, a fixed position, or a literal option name.
  //
  // The engine owns one MODEL per product (options + variants + server-formatted prices) and
  // RE-RENDERS the selectors whenever the flavour strip swaps us onto a different product.
  // That last part matters: sibling flavours genuinely carry different size runs (36-41 vs
  // 35-41 with half sizes), so the previous behaviour of swapping the variant list while
  // leaving the old size chips on screen offered sizes the new product does not sell.
  var Engine = (function () {
    var idField = $("fpe-variant-id"), priceEl = $("priceAmt"), addBtn = $("addBtn");
    var box = $("fpeOptions");
    var model = null, selected = [], booted = false;

    function nOptions() { return (model && model.options && model.options.length) || 0; }

    // Past the Liquid cap the variant array is truncated, so availability and the target variant
    // both have to come from what the SERVER resolved, not from a local search.
    function serverValues(pos) {
      if (!model || !model.pastCap || !model.optionValues) return null;
      for (var i = 0; i < model.optionValues.length; i++) {
        if (model.optionValues[i].position === pos) return model.optionValues[i].values;
      }
      return null;
    }
    function serverEntry(pos, value) {
      var vals = serverValues(pos);
      if (!vals) return null;
      for (var i = 0; i < vals.length; i++) {
        if (String(vals[i].v) === String(value)) return vals[i];
      }
      return null;
    }

    // Does variant v satisfy every current selection, ignoring one position?
    // (ignorePos 0 ignores nothing — option positions are 1-based.)
    function matches(v, ignorePos) {
      var opts = v.options || [];
      for (var p = 1; p <= nOptions(); p++) {
        if (p === ignorePos) continue;
        var want = selected[p - 1];
        if (want === null || want === undefined) continue;
        if (String(opts[p - 1]) !== String(want)) return false;
      }
      return true;
    }
    function findVariant() {
      if (!model) return null;
      for (var i = 0; i < model.variants.length; i++) {
        if (matches(model.variants[i], 0)) return model.variants[i];
      }
      return null;
    }
    // A value is selectable when SOME in-stock variant carries it AND satisfies every OTHER
    // current selection. Conditioning on siblings is the point: computing availability per
    // axis in isolation shows sizes that are only in stock on a cone colour you did not pick.
    function availableValues(pos) {
      var s = {};
      if (!model) return s;
      model.variants.forEach(function (v) {
        if (v.available === false) return;
        if (!matches(v, pos)) return;
        s[(v.options || [])[pos - 1]] = 1;
      });
      return s;
    }
    function priceFor(v) {
      if (v && model && model.prices && model.prices[v.id]) return model.prices[v.id];
      return priceEl ? priceEl.textContent : "";
    }

    // The flavour axis is driven by the swatch strip ONLY when cross-product siblings exist.
    // A consolidated product carries its flavours as real option values and must render them
    // as a real selector, or the customer can never change flavour at all.
    function isSwatchDriven(pos) {
      return !!(model && model.flavourBySwatches && model.axes && pos === model.axes.flavour);
    }

    function labelFor(o) {
      if (model.axes && o.position === model.axes.size) return o.name + ' <span class="sm">· EU</span>';
      return o.name;
    }

    function render() {
      if (!box || !model) return;
      box.innerHTML = "";
      model.options.forEach(function (o) {
        if (isSwatchDriven(o.position)) return;
        var wrap = document.createElement("div");
        wrap.className = "opt";
        var single = o.values.length <= 1;
        var lab = document.createElement("div");
        lab.className = "lab";
        lab.innerHTML = '<span class="l">' + labelFor(o) + "</span>" +
          (single ? '<span class="v">' + esc(o.values[0] || "") + "</span>" : "");
        wrap.appendChild(lab);
        if (!single) {
          var row = document.createElement("div");
          row.className = "sizes";
          row.setAttribute("data-opt-position", o.position);
          o.values.forEach(function (val) {
            var b = document.createElement("button");
            b.type = "button";
            b.className = "size";
            b.dataset.value = val;
            b.textContent = val;
            b.setAttribute("aria-pressed", String(selected[o.position - 1]) === String(val) ? "true" : "false");
            var se = serverEntry(o.position, val);
            if (se) {
              // `a` (available) and `id` are different facts. On a real product 4XL reports
              // available:true with NO variant — that combination does not exist for the
              // current selection. Offering it would be a dead end.
              b.dataset.variantId = se.id == null ? "" : String(se.id);
              if (se.id == null || se.a === false) { b.classList.add("oos"); b.setAttribute("aria-disabled", "true"); }
            }
            row.appendChild(b);
          });
          wrap.appendChild(row);
        }
        box.appendChild(wrap);
      });
      wire();
      regrey();
    }
    function esc(s) { var d = document.createElement("div"); d.textContent = s; return d.innerHTML; }

    function wire() {
      [].forEach.call(box.querySelectorAll("[data-opt-position]"), function (g) {
        var pos = +g.getAttribute("data-opt-position");
        [].forEach.call(g.querySelectorAll(".size"), function (b) {
          b.addEventListener("click", function () {
            // Past the cap the page cannot resolve the combination itself — one click, one
            // request, and the server sends back this section rendered for that variant.
            if (SectionRender.enabled()) {
              var vid = b.dataset.variantId;
              if (!vid) { toast("Not available in this combination"); return; }
              SectionRender.go(vid);
              return;
            }
            if (!availableValues(pos)[b.dataset.value]) {
              // Sold out HERE is not sold out everywhere. The page already knows which sibling
              // colourways can supply this size — it uses that to strike swatches through when a
              // size IS chosen — so the dead end is avoidable. Hand it to the availability module,
              // which owns that map; fall back to the bare toast if this is not a swatch family.
              if (pos === (model.axes && model.axes.size) && ui.onSoldOutSize
                  && ui.onSoldOutSize(b.dataset.value)) return;
              toast("Sold out — " + b.dataset.value);
              return;
            }
            selected[pos - 1] = b.dataset.value;
            [].forEach.call(g.querySelectorAll(".size"), function (x) { x.setAttribute("aria-pressed", "false"); });
            b.setAttribute("aria-pressed", "true");
            regrey(); update();
          });
        });
      });
    }
    function regrey() {
      if (!box) return;
      [].forEach.call(box.querySelectorAll("[data-opt-position]"), function (g) {
        var pos = +g.getAttribute("data-opt-position"), avail = availableValues(pos);
        // A truncated variant array would report most of the catalogue as sold out, so past the
        // cap the server's answer replaces it entirely rather than being merged with it.
        var srv = serverValues(pos);
        if (srv) {
          avail = {};
          srv.forEach(function (e) { if (e.a && e.id != null) avail[String(e.v)] = 1; });
        }
        [].forEach.call(g.querySelectorAll(".size"), function (b) {
          if (!avail[b.dataset.value]) { b.setAttribute("aria-disabled", "true"); b.classList.add("oos"); }
          else { b.removeAttribute("aria-disabled"); b.classList.remove("oos"); }
        });
      });
    }
  // ---- stock line -------------------------------------------------------------------------
    // It sits directly under the size picker now, so a shopper reads it as a fact about the size
    // they just chose. product-inventory renders server-side for the FIRST AVAILABLE variant only,
    // and Impulse refreshes it from its own product controller — which this section does not run.
    // Left alone, picking a different size would leave the previous size's stock number sitting
    // under it, which is worse in the new position than it was at the bottom of the column.
    function updateStock(v) {
      var host = document.querySelector("#fpe .fpe-stock");
      var out = host && host.querySelector("[data-product-inventory]");
      if (!host || !out) return;
      var li = out.closest(".sales-point");
      var wrap = out.closest(".icon-and-text");
      var data = document.querySelector("#fpe .js-product-inventory-data");
      var pid = data && data.getAttribute("data-product-id");
      var rec = (v && pid && window.inventories && window.inventories[pid]) ? window.inventories[pid][v.id] : null;

      // No tracked record means Shopify is not counting this variant. Say nothing rather than
      // guess — the same rule the rest of this page follows for absent facts.
      if (!rec) { if (li) li.classList.add("hide"); return; }
      var qty = parseInt(rec.quantity, 10); if (isNaN(qty)) qty = 0;
      if (qty <= 0) { if (li) li.classList.add("hide"); return; }
      if (li) li.classList.remove("hide");

      var threshold = parseInt(out.getAttribute("data-threshold"), 10);
      if (isNaN(threshold)) threshold = 0;
      var low = qty <= threshold;
      if (wrap) wrap.classList.toggle("inventory--low", low);
      if (!low) { out.textContent = host.getAttribute("data-inv-in") || ""; return; }
      var tpl = qty === 1 ? host.getAttribute("data-inv-low-one") : host.getAttribute("data-inv-low-many");
      out.textContent = (tpl || "").replace(qty === 1 ? "1" : "2", String(qty));
    }

    function update() {
      var v = findVariant();
      // Never leave a stale id in the form: if the current selection resolves to nothing, the
      // hidden input is cleared and the button is disabled, so a submit cannot buy the previous
      // variant while the page is showing a different one.
      if (idField) idField.value = v ? v.id : "";
      if (v && priceEl) priceEl.textContent = priceFor(v);
      updateStock(v);
      if (addBtn) {
        // The label is merchant-editable (section setting "Add-to-bag button"), handed over on the
        // button itself. Read here rather than captured once, because this runs on every variant
        // change and the literal used to win back over whatever the merchant had set.
        if (v && v.available !== false) { addBtn.disabled = false; addBtn.textContent = (addBtn.dataset.addLabel || "Add to bag") + " — " + priceFor(v); }
        else { addBtn.disabled = true; addBtn.textContent = v ? "Sold out" : "Unavailable in this combination"; }
      }
      // Nothing about a variant change is visible to a screen reader otherwise — the price and
      // the button label both mutate silently. Suppressed on first paint so the live region
      // doesn't fire the moment the page loads.
      if (booted) {
        if (v && v.available !== false) announce("Selected " + (v.options || []).join(", ") + ". " + priceFor(v));
        else if (!v) announce("That combination is not available.");
      }
      if (ui.onVariantChange) ui.onVariantChange(v, model);
    }

    // Load a product model. `keep` preserves the shopper's size across a flavour swap when the
    // incoming product actually sells it — losing the size on every swatch click is worse than
    // an occasional reset.
    function load(m, keep) {
      if (!m || !m.options) return;
      var prevSize = null;
      if (keep && model && model.axes && model.axes.size) prevSize = selected[model.axes.size - 1];
      model = m;
      selected = new Array(m.options.length);
      // seed from the model's own default variant, then re-apply the kept size if it exists
      var seed = m.selected || (m.variants[0] && m.variants[0].options) || [];
      for (var i = 0; i < m.options.length; i++) selected[i] = seed[i] != null ? seed[i] : null;
      if (prevSize != null && m.axes && m.axes.size) {
        var sizeOpt = null;
        m.options.forEach(function (o) { if (o.position === m.axes.size) sizeOpt = o; });
        if (sizeOpt && sizeOpt.values.indexOf(prevSize) !== -1) selected[m.axes.size - 1] = prevSize;
      }
      render();
      update();
      booted = true;
    }
    // `size` is read by the cross-axis availability module below. It cannot use current() for
    // this: current() returns null whenever the combination does not resolve, which is exactly
    // the case where knowing the chosen size matters most.
    function chosenSize() {
      if (!model || !model.axes || !model.axes.size) return null;
      var v = selected[model.axes.size - 1];
      return v == null ? null : String(v);
    }
    return { load: load, current: findVariant, model: function () { return model; },
             size: chosenSize, refresh: function () { regrey(); update(); } };
  })();

  // boot from the server-rendered model for the current product
  if (FPE.flavours && FPE.currentHandle && FPE.flavours[FPE.currentHandle]) {
    Engine.load(FPE.flavours[FPE.currentHandle], false);
  } else if (FPE.options) {
    Engine.load({ options: FPE.options, variants: FPE.variants || [], prices: FPE.prices || {},
                  selected: FPE.selected || [], axes: FPE.axes || {}, flavourBySwatches: !!FPE.flavourBySwatches }, false);
  }

  // ---- Material card: refuse to open when there is nothing behind the chevron ----
  // The CSS drops the chevron and the pointer cursor, but a <details> still toggles on a click
  // anywhere in the summary and on Enter/Space when focused. Without this the card would keep
  // silently opening onto an empty body — the exact behaviour that reads as a broken toggle.
  (function () {
    var mat = $("material");
    if (!mat) return;
    mat.addEventListener("click", function (e) {
      if (mat.getAttribute("data-note") === "false") e.preventDefault();
    });
    // Belt and braces: a programmatic open (or a browser find-in-page expanding it) bypasses the
    // click handler entirely.
    mat.addEventListener("toggle", function () {
      if (mat.open && mat.getAttribute("data-note") === "false") mat.open = false;
    });
  })();

  // ---- drawer (a real modal dialog) ----
  // The panel stays in the layout at translateX(100%) with an explicit display:flex, so a closed
  // drawer used to leave up to 8 controls keyboard-tabbable off-screen inside an aria-hidden
  // subtree. `inert` (set in markup, toggled here) removes them from the tab order and the
  // accessibility tree together, and Tab is trapped while open.
  (function () {
    var openB = $("openDrawer"), closeB = $("closeDrawer"), scrim = $("drawerScrim"), drawer = $("drawer");
    if (!fpe || !drawer) return;
    var SEL = 'a[href],button:not([disabled]),input:not([disabled]),select,textarea,[tabindex]:not([tabindex="-1"])';
    function focusables() { return [].slice.call(drawer.querySelectorAll(SEL)); }
    function open() {
      fpe.classList.add("drawer-open");
      drawer.removeAttribute("inert");
      drawer.setAttribute("aria-hidden", "false");
      document.documentElement.classList.add("js-drawer-open");
      if (closeB) closeB.focus();
    }
    function close() {
      fpe.classList.remove("drawer-open");
      drawer.setAttribute("aria-hidden", "true");
      drawer.setAttribute("inert", "");
      document.documentElement.classList.remove("js-drawer-open");
      if (openB) openB.focus();
    }
    function isOpen() { return fpe.classList.contains("drawer-open"); }
    if (openB) openB.addEventListener("click", open);
    if (closeB) closeB.addEventListener("click", close);
    if (scrim) scrim.addEventListener("click", close);
    [].forEach.call(document.querySelectorAll("[data-close-drawer]"), function (el) { el.addEventListener("click", close); });
    if (firstRun) document.addEventListener("keydown", function (e) {
      if (!isOpen()) return;
      if (e.key === "Escape") { close(); return; }
      if (e.key !== "Tab") return;
      var f = focusables(); if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    });
  })();

  // ---- AR try-on (demo toast) ----
  (function () { var b = $("vtoBtn"); if (b) b.addEventListener("click", function () { toast("See it on your foot — AR try-on"); }); })();

  // ---- flavour configurator: client-side preview swap from custom.flavor_color swatches ----
  (function () {
    var swBox = $("flavourSwatches"); if (!swBox) return;
    function setText(id, t) { var el = $(id); if (el) el.textContent = t; }
    function toggle(id, show) { var el = $(id); if (el) { if (show) el.removeAttribute("hidden"); else el.setAttribute("hidden", ""); } }
    var FLAVOURS = [].map.call(swBox.querySelectorAll(".sw"), function (b) {
      // `cone` is read here as well as `mat` — the facet filter is data-driven off these keys, so
      // an unmapped attribute means that facet silently sees zero values and deletes its own row.
      return { el: b, handle: b.dataset.handle || "", img: b.dataset.img, name: b.dataset.name || "", colour: b.dataset.colour || "", mat: b.dataset.mat || "", matIcon: b.dataset.matIcon || "", cone: b.dataset.cone || "", vegan: b.dataset.vegan === "true", recycled: b.dataset.recycled === "true" };
    });
    // Locate the current product by HANDLE rather than trusting DOM order. Assuming index 0 is
    // how ui.vegan and ui.baseImg ended up seeded from a sibling when the current product's own
    // swatch was missing from the strip.
    var active = 0;
    for (var fi = 0; fi < FLAVOURS.length; fi++) {
      if (FLAVOURS[fi].handle && FLAVOURS[fi].handle === FPE.currentHandle) { active = fi; break; }
    }
    // the product the page was SERVED as — the baseline every swap is described against
    var origin = (FPE.flavours || {})[FPE.currentHandle] || null;
    ui.vegan = FLAVOURS[active] ? FLAVOURS[active].vegan : false;
    ui.recycled = FLAVOURS[active] ? FLAVOURS[active].recycled === true : false;
    ui.baseImg = FLAVOURS[active] ? FLAVOURS[active].img : null;

    function applyFlavour(announceIt) {
      var f = FLAVOURS[active];
      // A swatch only changes the page when it resolves to a real product model. Without this
      // guard the identity fields below were rewritten to the sibling while the cart kept the
      // ORIGINAL product — a Recycled Leather shoe could be relabelled "Vegan" with cork
      // provenance copy while Add-to-bag still posted the leather variant.
      var fd = (FPE.flavours || {})[f.handle];
      if (!fd) { if (f.el && f.url) location.href = f.url; return; }

      FLAVOURS.forEach(function (x, i) { x.el.setAttribute("aria-pressed", i === active ? "true" : "false"); });
      var sf = $("subFlav"); if (sf) sf.textContent = f.name;
      // The colour half is its own element now — see the section markup for why. Without this the
      // name swapped and the colour stayed on whatever the page first rendered.
      var sfc = $("subFlavCol");
      if (sfc) sfc.textContent = (f.colour && f.colour !== f.name) ? " \u00B7 " + f.colour : "";
      // The à-la badge on the hero had the same problem as the colour: nothing updated it, so it
      // kept the first product's kind. Siblings on the products checked so far are all one kind,
      // which is why it never showed — but flavor_color links related products, not same-kind
      // ones, so it is only latent. data-k moves with the text because it drives the colour.
      var ab = $("alaBadge");
      if (ab) {
        if (fd.ala) { ab.textContent = fd.ala; ab.setAttribute("data-k", fd.alaKind || ""); ab.hidden = false; }
        else { ab.hidden = true; }
      }
      setText("flavLabel", f.name + (f.colour && f.colour !== f.name ? " | " + f.colour : ""));
      // Material name and provenance come from the product's own data. The old MATERIALS table
      // carried a hand-written sentence per material plus a blanket "96% bio-based & recycled"
      // fallback for anything unrecognised — an unsubstantiated claim on compound values like
      // "Recycled Lycra & Recycled Leather". Unknown now renders nothing.
      setText("matName", fd.mat || "");
      // The provenance copy never moved with the swap — only the material NAME and icon did — so
      // a product with a note handed its sentence to the next material the shopper landed on.
      // data-note goes with it because it decides whether the card is a disclosure at all; see
      // the Material block in the section markup.
      var mat = $("material"), did = $("matDid");
      if (did) did.innerHTML = fd.matNote || "";
      if (mat) {
        // The brand facts are shop-wide and stay put across a swap; only the per-product note
        // moves. So the card is a real disclosure whenever EITHER is present — checking just the
        // note would collapse it to a static card on every product Holly has not written one for,
        // while the facts sat visible behind a chevron that refused to open.
        var body = !!fd.matNote || mat.getAttribute("data-facts") === "true";
        mat.setAttribute("data-note", body ? "true" : "false");
        if (!body) mat.open = false;
      }
      var micon = $("matIcon"); if (micon) { if (fd.matIcon) { micon.hidden = false; micon.src = fd.matIcon; } else { micon.hidden = true; } }
      toggle("matVegPill", fd.vegan);
      var leaf = $("matLeaf"); if (leaf) leaf.classList.toggle("on", fd.vegan);
      // The heading is COMPOSED from metafields, so a swap has to rebuild it rather than drop in
      // the raw title. A sibling can differ in category, material, heel AND a-la kind — they are
      // linked by custom.flavor_color, which relates products, not same-spec products.
      renderComposedTitle(fd);

      // The stated cone colour must follow the swap. custom.flavor_color links RELATED products,
      // not same-heel ones: popsandals-cork-swirl-cone is a Gold cone whose "flavour" siblings
      // include five Silver ones. Leaving this alone displayed "Gold" on a page that had swapped
      // to a Silver product and was about to put a Silver cone in the cart.
      // The heel row that used to live here is gone — the composed title above states the heel,
      // and repeating it beside the size chips looked like a control without being one. Nothing
      // to keep in sync on a swap any more; where the heel IS a real option the Engine renders a
      // proper selector and owns it entirely.
      // Toppings only attach to a MAGNETIC pair, and custom.flavor_color links related products,
      // not same-kind ones — so a swatch can land on a topless sibling. The picker is rendered by
      // Liquid for the SERVED product and does not re-render, which left it offering toppings for
      // a shoe that physically cannot take one. Latent until now; the badges over the photo would
      // have made it plainly visible.
      var addons = $("fpeAddons");
      if (addons) {
        var canTakeToppings = fd.alaKind === "magnetic";
        if (canTakeToppings) {
          addons.removeAttribute("hidden");
        } else {
          addons.setAttribute("hidden", "");
          [].forEach.call(addons.querySelectorAll(".addon-cb:checked"), function (cb) {
            cb.checked = false;
            var lab = cb.closest(".addon"); if (lab) lab.classList.remove("on");
          });
          if (ui.syncAddons) ui.syncAddons();   // clears ui.extras and repaints the badges
        }
      }

      ui.vegan = fd.vegan; ui.recycled = fd.recycled === true; ui.baseImg = fd.img; ui.flavNative = (active === 0);
      setHero(fd.img, fd.alt || fd.title);
      renderBadges();

      // real in-page product swap: options, variants and prices together — sibling flavours
      // genuinely sell different size runs, so the selectors are re-rendered, not left stale.
      Engine.load(fd, true);
      if (ui.rebuildRail) ui.rebuildRail(fd.images && fd.images.length ? fd.images : (fd.img ? [fd.img] : []));
      if (fd.title) document.title = fd.title;

      // The visible "Also changes to Cork and Rose Gold cone." line used to be written here.
      // Removed at Peter's call: the shopper can see the material and the heel change in the
      // heading and the spec lines as they happen, so a sentence restating it was commentary on
      // the page rather than information about the shoe.
      //
      // #flavNote itself STAYS — the facet filter below writes its match count into it. Do not
      // delete the element on the strength of this comment.
      //
      // The change is still ANNOUNCED, because the one audience that cannot see the heading
      // rewrite itself is a screen-reader user, and losing a silver heel you did not choose is
      // the failure this was guarding against.
      var moved = [];
      if (origin) {
        if (fd.mat && origin.mat && fd.mat !== origin.mat) moved.push(fd.mat);
        if (fd.cone && origin.cone && fd.cone !== origin.cone) moved.push(fd.cone + " cone");
      }
      if (announceIt !== false) {
        announce((fd.title || f.name) + " selected. " + (fd.price || "") +
                 (moved.length ? " Also changes to " + moved.join(" and ") + "." : ""));
      }
    }
    // clicking a flavour = full in-page product swap + shareable URL (no navigation); popstate re-swaps on back/forward
    function pushURL(handle) {
      var fd = (FPE.flavours || {})[handle];
      if (fd && fd.url && handle !== FPE.currentHandle && window.history && history.pushState) {
        history.pushState({ flavour: handle }, "", fd.url); FPE.currentHandle = handle;
      }
    }
    FLAVOURS.forEach(function (f, i) { f.el.addEventListener("click", function () { if (f.el.classList.contains("dim")) return; active = i; applyFlavour(); pushURL(f.handle); }); });
    if (firstRun) addEventListener("popstate", function (e) {
      var h = (e.state && e.state.flavour) || null;
      if (!h) { for (var k = 0; k < FLAVOURS.length; k++) { if (FLAVOURS[k].handle && location.pathname.indexOf(FLAVOURS[k].handle) !== -1) { h = FLAVOURS[k].handle; break; } } }
      if (!h) return;
      for (var j = 0; j < FLAVOURS.length; j++) { if (FLAVOURS[j].handle === h && j !== active) { active = j; FPE.currentHandle = h; applyFlavour(); break; } }
    });

    // ---- facet filters over the linked family (material, heel) ----------------------------
    // Heel colour is NOT a variant axis anywhere in this catalogue: of 377 ACTIVE products, 48
    // carry a cone option and every one is pinned to a single value. The variety exists only as
    // SEPARATE products. So a heel picker cannot be a selector — but the family genuinely spans
    // heels, so it can be a FILTER across the linked products, which is what the material filter
    // already did. Same mechanism, second facet.
    //
    // Filtering dims rather than hides, and jumps to a matching flavour, so the shopper always
    // lands on a product that actually exists. That is the difference between this and the heel
    // swatch strip that was removed: this navigates to real products instead of advertising
    // combinations the catalogue does not contain.
    (function () {
      var FACETS = [
        { key: "mat",  box: $("matFilter"),  label: "material", icons: true },
        { key: "cone", box: $("coneFilter"), label: "heel",     icons: false }
      ].filter(function (x) { return x.box; });
      if (!FACETS.length) return;

      var filters = {};
      var icons = {};
      FLAVOURS.forEach(function (f) { if (f.mat && f.matIcon && !icons[f.mat]) icons[f.mat] = f.matIcon; });

      function valuesFor(key) {
        var out = [], seen = {};
        FLAVOURS.forEach(function (f) { var v = f[key]; if (v && !seen[v]) { seen[v] = 1; out.push(v); } });
        return out;
      }
      // Does this flavour satisfy every active filter EXCEPT the one being counted?
      function matches(f, ignoreKey) {
        for (var k in filters) {
          if (!filters[k] || k === ignoreKey) continue;
          if (f[k] !== filters[k]) return false;
        }
        return true;
      }
      function count(key, val) {
        var n = 0;
        FLAVOURS.forEach(function (f) { if (f[key] === val && matches(f, key)) n++; });
        return n;
      }
      function activeLabel() {
        var bits = [];
        FACETS.forEach(function (fc) { if (filters[fc.key]) bits.push(filters[fc.key]); });
        return bits.join(" · ");
      }
      // The name of each filtered axis, read from the row's own label in the DOM rather than the
      // hardcoded fc.label, so the sentence keeps matching the screen after those labels became
      // merchant settings. Falls back to fc.label if the markup ever changes shape.
      function activeAxisNames() {
        var names = [];
        FACETS.forEach(function (fc) {
          if (!filters[fc.key]) return;
          var el = fc.box && fc.box.previousElementSibling;
          var t = (el && el.className === "fl") ? (el.textContent || "").trim() : "";
          names.push((t || fc.label).toLowerCase());
        });
        return names;
      }

      function apply() {
        var shown = 0;
        FLAVOURS.forEach(function (f) {
          var ok = matches(f, null);
          if (ok) shown++;
          f.el.classList.toggle("dim", !ok);
          if (ok) f.el.removeAttribute("aria-disabled"); else f.el.setAttribute("aria-disabled", "true");
        });
        // never strand the shopper on a dimmed product
        if (shown && !matches(FLAVOURS[active], null)) {
          for (var i = 0; i < FLAVOURS.length; i++) {
            if (matches(FLAVOURS[i], null)) { active = i; applyFlavour(); pushURL(FLAVOURS[i].handle); break; }
          }
        }
        var note = $("flavNote");
        if (note) {
          var lab = activeLabel();
          if (lab) {
            // "the rest are faded" described the effect without explaining the cause, which is
            // the one thing the shopper actually needs: the faded ones are still real, buyable
            // styles, they just sit outside the filter. Naming the axis says that. "differ in"
            // rather than "are a different" so it stays grammatical whatever the label is renamed
            // to — "differ in ingredients" reads, "are a different ingredients" does not.
            var axes = activeAxisNames();
            var why = axes.length ? " The faded ones differ in " + axes.join(" or ") + "." : "";
            note.textContent = "Showing the " + shown + " " + lab + " style" + (shown === 1 ? "" : "s") + "." + why;
            note.classList.add("on");
          } else { note.textContent = ""; note.classList.remove("on"); }
        }
        FACETS.forEach(function (fc) {
          [].forEach.call(fc.box.children, function (c) {
            c.setAttribute("aria-pressed", c.dataset.val === (filters[fc.key] || "") ? "true" : "false");
            var n = c.dataset.val ? count(fc.key, c.dataset.val) : shown;
            var ct = c.querySelector(".ct"); if (ct) ct.textContent = "· " + n;
            c.disabled = c.dataset.val ? n === 0 : false;
          });
        });
      }

      FACETS.forEach(function (fc) {
        var vals = valuesFor(fc.key);
        // A one-option filter is noise, not a choice — drop the whole row.
        if (vals.length < 2) { var row = fc.box.closest(".facetrow"); if (row) row.remove(); return; }
        filters[fc.key] = null;
        function chip(val, text) {
          var b = document.createElement("button");
          b.type = "button"; b.className = "mfchip"; b.dataset.val = val || "";
          var ic = (val && fc.icons && icons[val])
            ? '<img class="mfchip-ic" src="' + icons[val] + '" alt="" width="24" height="24" onerror="this.remove()">' : "";
          b.innerHTML = ic + text + ' <span class="ct"></span>';
          b.addEventListener("click", function () {
            // clicking the active chip clears it — a filter you cannot undo is a trap
            filters[fc.key] = (filters[fc.key] === val) ? null : val;
            apply();
          });
          fc.box.appendChild(b);
        }
        chip(null, "All");
        vals.forEach(function (v) { chip(v, v); });
      });
      // a heading with no rows under it is worse than no heading
      var group = $("facets");
      if (group && !group.querySelector(".facetrow")) group.remove();
      apply();
    })();

    // ---- cross-axis availability: can these colourways actually sell the chosen size? --------
    // The two controls were computed in different universes. The size chips are scoped to ONE
    // product and correctly grey out that product's sold-out sizes; the swatches are cross-
    // product. Nothing reconciled them, so picking 38.5 said nothing about the other colourways,
    // and every swatch looked equally buyable.
    //
    // On the live Cherriots family (20 linked products) that gap is wide: size 40 is sellable by
    // 5 of 20 and size 41 by 5 of 20, while 35 / 36.5 / 40.5 / 42 / 43 appear in the family and
    // are sellable by NONE. One colourway (Blueberry) has all nine of its sizes sold out and
    // still rendered as an ordinary swatch.
    //
    // This marks rather than hides, and never blocks the click: a shopper who wants Chocolate
    // may happily take a different size, and removing the swatch would hide that the colour
    // exists at all. The strike-through carries the state alongside the fade, so it is not
    // colour-only.
    (function () {
      var note = $("sizeNote");

      function sizeAxis(fd) { return (fd && fd.axes && fd.axes.size) || 0; }

      // Sizes this product can actually SELL — an available variant, not merely a listed option
      // value. A sold-out size still appears in options_with_values, which is why the option list
      // alone is not an answer.
      function sellable(fd) {
        var out = {}, pos = sizeAxis(fd);
        if (!pos || !fd.variants) return out;
        fd.variants.forEach(function (v) {
          if (v.available === false) return;
          var val = (v.options || [])[pos - 1];
          if (val != null) out[String(val)] = 1;
        });
        return out;
      }

      // Precomputed once: the per-colourway sellable set never changes client-side.
      var SELL = {}, DEAD = {};
      FLAVOURS.forEach(function (f) {
        var fd = (FPE.flavours || {})[f.handle];
        if (!fd) return;
        SELL[f.handle] = sellable(fd);
        // A colourway with nothing available at all is worth saying regardless of size.
        DEAD[f.handle] = sizeAxis(fd) ? Object.keys(SELL[f.handle]).length === 0 : false;
      });

      function apply() {
        var size = Engine.size();
        var ok = 0, total = 0, anyKnown = false;
        FLAVOURS.forEach(function (f) {
          var bad;
          if (!SELL[f.handle]) {
            bad = false;                                     // unresolvable sibling — say nothing
          } else if (f.el.classList.contains("dim")) {
            // Dimmed by the facet filter, so it is not one of the colourways on offer right now.
            // Counting it made the denominator describe a set the shopper cannot see: with
            // Recycled Leather selected the strip showed 5 swatches while the line said "of 8".
            // The strike-through itself still applies, so a later filter change reveals a swatch
            // already correctly marked.
            bad = !SELL[f.handle][Engine.size()];
          } else {
            anyKnown = true;
            if (size == null) {
              // No size chosen yet, so the only thing worth flagging is a colourway with nothing
              // available in ANY size — true regardless of what the shopper picks next.
              bad = DEAD[f.handle];
            } else {
              // A fully sold-out colourway has an empty sellable set, so it falls out of this
              // test naturally. It MUST still count toward the total: it is a colourway that
              // cannot sell this size, and excluding it made the strip show 20 swatches while
              // the line said "of 19".
              total++;
              bad = !SELL[f.handle][size];
              if (!bad) ok++;
            }
          }
          f.el.classList.toggle("nosize", bad);
          // aria-disabled, not disabled: the control still works, it just cannot give you THIS
          // size. Only set when true so it never fights the facet filter's own aria-disabled.
          if (bad) f.el.setAttribute("data-nosize", "true"); else f.el.removeAttribute("data-nosize");
        });
        if (!note) return;
        // Only speak when there is a LIMIT to report. "Every colourway is in stock in 39" is the
        // absence of a problem, and printing it makes the shopper read a line to learn nothing —
        // worse, it trains them to skip the line on the products where it does matter.
        if (size != null && total && anyKnown && ok < total) {
          // "available in size 36" rather than "in stock in 36". Today every variant on this
          // store is inventory_policy: deny, so the two mean the same thing — but `sellable()`
          // tests variant.available, which is also true for a continue-selling variant with no
          // stock. The day Holly turns oversell on for one product, "in stock" becomes a false
          // claim and "available" stays true.
          note.textContent = ok + " of " + total + " colourways are available in size " + size +
                             ". The struck-through ones are not.";
          note.classList.add("on");
        } else { note.textContent = ""; note.classList.remove("on"); }
      }

      // A struck-through swatch is still clickable, but say what will happen rather than letting
      // the size silently reset. Engine.load(fd, true) only keeps the size when the incoming
      // product lists it, so the shopper would otherwise just find themselves on a different one.
      FLAVOURS.forEach(function (f) {
        f.el.addEventListener("click", function () {
          if (!f.el.classList.contains("nosize") || f.el.classList.contains("dim")) return;
          var size = Engine.size();
          toast(DEAD[f.handle]
            ? (f.name || "This colourway") + " is sold out in every size"
            : (f.name || "This colourway") + " has no " + size + " — showing its sizes");
        }, true);
      });

      // Clicking a size this product cannot sell: name the colourways that CAN, and make them
      // clickable. Same SELL map the strike-through uses, read the other way round. Returns true
      // when it has something to say, so the Engine knows not to fall back to the bare toast.
      ui.onSoldOutSize = function (size) {
        if (!note || size == null) return false;
        var can = FLAVOURS.filter(function (f) {
          return SELL[f.handle] && SELL[f.handle][size] && !f.el.classList.contains("dim");
        });
        if (!can.length) {
          note.textContent = "Size " + size + " is sold out in every colourway.";
          note.classList.add("on");
          announce(note.textContent);
          return true;
        }
        note.textContent = "";
        note.appendChild(document.createTextNode("Size " + size + " is sold out here \u2014 available in "));
        can.slice(0, 4).forEach(function (f, i, arr) {
          var b = document.createElement("button");
          b.type = "button";
          b.className = "sizealt";
          b.textContent = f.name || f.handle;
          b.addEventListener("click", function () { f.el.click(); });
          note.appendChild(b);
          if (i < arr.length - 1) note.appendChild(document.createTextNode(", "));
        });
        if (can.length > 4) {
          note.appendChild(document.createTextNode(" and " + (can.length - 4) + " more"));
        }
        note.classList.add("on");
        announce("Size " + size + " is sold out in this colourway. Available in " +
                 can.map(function (f) { return f.name || f.handle; }).join(", ") + ".");
        return true;
      };

      // Re-run whenever the variant selection moves. update() fires this on every size click and
      // once per flavour swap, which is exactly the set of moments the answer can change.
      ui.onVariantChange = function () { apply(); };
      apply();
    })();

    // Reserve the title height across every sibling flavour so swapping never shifts the buy
    // column. Now measured against the real product TITLES (the h1 content since the composed
    // "{colour} {vegan} {type}" line was demoted to the subtitle for being non-identifying).
    function reserveTitle() {
      var h1 = $("fpeTitle"), spec = $("fpeSpec");
      if (!h1) return;
      // Measure the WHOLE heading group. Reserving on the h1 alone was the cause of the gap
      // Holly reported: a static min-height of 2.12em held two lines of a 2.75rem heading open
      // even when the title was one line, leaving ~46px of dead space under short titles.
      var wrap = h1.parentNode;
      var current = { html: h1.innerHTML, cls: h1.className,
                      spec: spec ? spec.innerHTML : null, hid: spec ? spec.hidden : null };
      h1.style.minHeight = "0px";
      var max = 0;
      FLAVOURS.forEach(function (f) {
        var fd = (FPE.flavours || {})[f.handle];
        if (!fd) return;
        renderComposedTitle(fd);
        var h = h1.offsetHeight + (spec && !spec.hidden ? spec.offsetHeight : 0);
        if (h > max) max = h;
      });
      h1.innerHTML = current.html; h1.className = current.cls;
      if (spec) { spec.innerHTML = current.spec; spec.hidden = current.hid; }
      // Only reserve when there is actually something to swap between.
      if (max && FLAVOURS.length > 1) {
        var own = h1.offsetHeight + (spec && !spec.hidden ? spec.offsetHeight : 0);
        h1.style.minHeight = Math.max(0, max - (own - h1.offsetHeight)) + "px";
      } else {
        h1.style.minHeight = "";
      }
    }
    reserveTitle();
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(reserveTitle);
    var rt; if (firstRun) addEventListener("resize", function () { clearTimeout(rt); rt = setTimeout(reserveTitle, 150); });
  })();

  /* REMOVED — the legacy cone-colour (heel) swatch strip.
     It was built from custom.choose_your_cone_color, which is not an axis: in the linked-product
     model each product is one fixed (flavour × material × cone) combination, and within a style
     every flavour exists in exactly one cone. On popsandals-recycled-leather-swirl-cone the single
     "Gold" reference is CHOCOLATE CHIP — there is no Bubblegum in gold.

     The handler compounded it by only calling setHero() and rewriting #heelLabel: the photo and
     the label changed while the variant, the price and the cart did not. A shopper could see a
     gold shoe labelled Gold and buy the silver one.

     Cone colour is now stated in Liquid as a fact. Products with other cones remain reachable
     through the flavour strip, which labels each sibling's own cone. A REAL cone variant option
     still renders through the Engine, which resolves availability properly. */

  /* REMOVED — the à-la "upgrade ladder" module.
     It rendered topless/mode/magnetic as selectable cards with aria-pressed (i.e. as an option
     the shopper picks) and priced them with `sib.price | minus: product.price`, which produced
     negative deltas: popsandals-cork-swirl-cone showed "À La Magnetic · Base" beside
     "À La Topless · -$70.00". Holly's rule is that a shoe is manufactured EITHER topless OR
     magnetic and can never be converted, so presenting it as a reversible discount tier was
     wrong on the product, and there is no price ladder to express anyway (one family spans
     $221.68-$610).
     It also mutated #drawerTotal without ever touching #priceAmt or #addBtn, so a customer could
     read "Configured · preview $290" while the button said "Add to bag — $360.00".
     The capability is now stated as a fact in Liquid, with links out to the sibling products.
     See snippets/fundae-ala-kind.liquid. */


  // ---- reveal on scroll (enhances an already-visible default) ----
  (function () {
    var els = (fpe || document).querySelectorAll(".reveal");
    if (!("IntersectionObserver" in window) || matchMedia("(prefers-reduced-motion: reduce)").matches) {
      [].forEach.call(els, function (el) { el.classList.add("in"); }); return;
    }
    var io = new IntersectionObserver(function (es) { es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add("in"); io.unobserve(e.target); } }); }, { threshold: .14 });
    [].forEach.call(els, function (el) { io.observe(el); });
  })();
};

/* Boot. FPE_INIT reads #fpe-data itself, so this is just the first call. */
window.FPE_INIT();
